import DocumentIcon from 'app/shared/componentsRestyled/coreDesignSystem/icons/DocumentIcon';
import GridSquaresIcon from 'app/shared/componentsRestyled/coreDesignSystem/icons/GridSquaresIcon';

/** @enum {string} */
export const BatchIntakeStep = {
  REVIEW: 'review',
  UPLOAD: 'upload',
};

/**
 * Backend staged-plan segment statuses the review flow discriminates on.
 * @enum {string}
 */
export const SegmentServerStatus = {
  UNRECOGNIZED: 'Unrecognized',
  FAILED: 'Failed',
};

/** Confidence threshold below which a segment is flagged for review */
export const LOW_CONFIDENCE_THRESHOLD = 0.8;

const BYTES_PER_MB = 1_048_576; // 1024 * 1024

/**
 * Maximum per-file size the backend accepts.
 * DEV-4527: applies individually to each file in a multi-file submission.
 */
export const SPLIT_MAX_FILE_SIZE_MB = 50;
export const SPLIT_MAX_FILE_SIZE_BYTES = SPLIT_MAX_FILE_SIZE_MB * BYTES_PER_MB;

/**
 * Accepted MIME types for the file input element.
 * DEV-4527: PDFs, common images, and ZIP archives are all accepted by the backend.
 */
export const ACCEPTED_FILE_TYPES =
  'application/pdf,image/jpeg,image/png,image/tiff,image/heic,image/webp,application/zip,.zip,.pdf,.jpg,.jpeg,.png,.tif,.tiff,.heic,.webp';

/** @enum {string} */
export const ReviewFilter = {
  ALL: 'all',
  NEEDS_REVIEW: 'needsReview',
};

/**
 * Mode tiles displayed below the dropzone headline.
 * DEV-4527: updated to reflect multi-source intake (PDFs, images, ZIP).
 */
export const INTAKE_MODE_TILES = [
  {
    id: 'combined-pdf',
    headline: '1 combined PDF',
    description: 'AI splits into separate docs',
    Icon: DocumentIcon,
  },
  {
    id: 'many-files',
    headline: 'Many files',
    description: 'AI categorizes each',
    Icon: GridSquaresIcon,
  },
];
